import { render, staticRenderFns } from "./CollectionPage.vue?vue&type=template&id=0bb18574&scoped=true&"
import script from "./CollectionPage.vue?vue&type=script&lang=js&"
export * from "./CollectionPage.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPage.vue?vue&type=style&index=0&id=0bb18574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb18574",
  null
  
)

export default component.exports